let deviceId = localStorage.getItem('deviceID');

if (!deviceId) {
  deviceId = createDeviceId(32);
  localStorage.setItem('deviceID', deviceId);
}

// Send deviceId to the server using jQuery AJAX
function setDeviceId() {
  let deviceId = localStorage.getItem('deviceID');
  let organizer_id =
    $('body').attr('organizer_id') ?? $('#dashboard_organizer_id').val();

  const currentLocationId = localStorage.getItem('mainLocationId')
    ? localStorage.getItem('mainLocationId')
    : localStorage.getItem(`${organizer_id}_mainLocationId`);
  $.ajax({
    url: '/ajax/admin_organizers/set_device_id',
    type: 'POST',
    data: { deviceID: deviceId, currentLocationId },
  })
    .done(function (response) {
      if (response.location_id && response.organizer_id) {
        localStorage.setItem(
          `${response.organizer_id}_mainLocationId`,
          response.location_id
        );
        localStorage.removeItem('mainLocationId');
      }
    })
    .fail(function (xhr, status, error) {
      console.error('Error storing Device ID:', error);
    });
}

$(document).on('click', '#add-payment-method-confirm', function () {
  const newPaymentMethodName = $('#newPaymenetInput').val();

  if (!newPaymentMethodName) {
    alert('Vennligst skriv inn betalingsmidler navn!');
    $('#newPaymenetInput').focus();
    return;
  }

  $.ajax({
    type: 'POST',
    url: '/api/v1/private/payment_method/new',
    data: { payment_method_name: newPaymentMethodName },
  })
    .done(function (data) {
      if (data.success) {
        $('#organizer_settings_form').submit();
      }

      $('#newPaymentModel').modal('hide');
      $('.modal-backdrop').remove();
    })
    .fail(function (data) {
      if (
        data.responseJSON.redirect_url !== undefined &&
        data.responseJSON.redirect_url !== null
      ) {
        document.location.href = data.responseJSON.redirect_url;
      }
    });
});

$(document).on('change', '#gift-card-maximum-sum', function () {
  const maxSum = $(this).val();
  const minSum = $('#gift-card-minimum-sum').val();
  const errorDiv = $('#gift-card-amount-error');

  if (parseFloat(maxSum) < parseFloat(minSum)) {
    errorDiv.html(
      `Maksimumsbeløpe kan ikke være mindre enn minimumsbeløpe ( ${minSum} )`.bold()
    );
    if (errorDiv.hasClass('d-none')) {
      errorDiv.removeClass('d-none');
    }
    $(this).val('');
    $(this).focus();
  } else {
    if (!errorDiv.hasClass('d-none')) {
      errorDiv.addClass('d-none');
    }
  }
});

$(document).on('change', '#multiple-select', function () {
  var paymentTerminalValue = $('#multiple-select').attr(
    'data-payment-terminal'
  );
  var selectedValues = $(this).val();

  if (selectedValues.includes(paymentTerminalValue)) {
    $(this).find('option[value^="terminal-"]').prop('selected', true);
  }
  $(this).selectpicker('refresh');
});

$(document).on('click', '.close-default-payment-alert', function () {
  const alertDiv = $('#default-payment-alert');
  alertDiv.addClass('d-none');
});

function checkDefaultPayments() {
  const checkedPayments = $('.default-payment:checked').length;
  const alertDiv = $('#default-payment-alert');
  return;
  if (checkedPayments > 5) {
    alertDiv.removeClass('d-none');
    $(event.target).prop('checked', false);
  } else {
    alertDiv.addClass('d-none');
  }
}

$(document).ready(function () {
  let organizer_settings_ajax_lock = false;
  let p = $('body').attr('p');

  let posType = localStorage.getItem('postype');
  if (posType === 'classic') {
    $('#pos_scroll').attr('checked', false);
    $('#pos_classic').attr('checked', true);
  } else {
    $('#pos_classic').attr('checked', false);
    $('#pos_scroll').attr('checked', true);
  }

  let storedDeviceId = localStorage.getItem('deviceID');
  deviceId = storedDeviceId || deviceId;

  if (storedDeviceId) {
    $('#device_id').val(storedDeviceId);
    $('#pos_device_id').val(storedDeviceId);
  }

  const mainPOSDeviceId = $('#main_pos_device_id').val();
  if (mainPOSDeviceId == deviceId) {
    $('#main_pos').prop('checked', true);
  }

  $(document).on('change', 'input[name="pos_type"]', function () {
    var selectedValue = $('input[name="pos_type"]:checked').val();
    localStorage.setItem('postype', selectedValue);
  });

  if (window.ReactNativeWebView) {
    $('#main-pos-setting').attr('hidden', false);
  }

  $(document).on('change', '#main_pos', function () {
    if ($(this).is(':checked')) {
      $('#main-pos-confirm-model').modal('show');
    } else {
      $('#main-pos-warning')
        .fadeIn(300)
        .toast({
          autohide: false,
        })
        .toast('show');

      // Set the checkbox back to checked state
      $(this).prop('checked', true);
    }
  });

  $(document).on('click', '#main-pos-warning .close', function () {
    $('#main-pos-warning').css('display', 'none');
  });

  $(document).on('click', '#main-pos-confirm', function () {
    $('#main_pos').prop('checked', true);
    if (!deviceId) {
      deviceId = createDeviceId(32);
      localStorage.setItem('deviceID', deviceId);
    }
    const organizerId = $('#main_pos').attr('data-organizer-id');
    updateMainPOSDevice(deviceId, organizerId);
    $('#main-pos-confirm-model').modal('hide');
    $('#takeaway-printer').prop('disabled', false);
    $('#takeaway-printer').removeClass('disabled');
    $('button[data-id=takeaway-printer]').removeClass('disabled');
  });

  $(document).on('click', '#main-pos-cancel', function () {
    $('#main_pos').prop('checked', false);
  });

  function updateMainPOSDevice(deviceId, organizerId) {
    try {
      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_settings/update_main_pos_device',
        data: {
          main_pos_device_id: deviceId,
          organizer_id: organizerId,
        },
      })
        .done(function (data) {
          if (data.success) {
            popupAlert();
            getOrderToPrint().always(() => {
              isPullOrderPending = false;
            });
            $('#takeaway-printer').prop('disabled', false);
            return;
          } else {
            return alert(data.error);
          }
        })
        .fail(function (data) {
          return alert('Mislykkes i å angi HovedPOS');
        });
    } catch (error) {
      console.error(error);
    }
  }

  //delete customer screen picture

  $(document).on('click', '.delete-customer-picture', function () {
    let organizer_id = $(this).data('organizer-id');
    let customer_picture = $(this).data('customer-picture');
    let confirm_message = $(this).data('confirm-message');

    if (!confirm(confirm_message)) {
      return false;
    }

    $.ajax({
      type: 'POST',
      url: '/ajax/organizer_settings/delete_customer_screen_image',
      data: {
        organizer_id: organizer_id,
        customer_picture: customer_picture,
      },
    })
      .done(function (data) {
        if (data.message !== undefined && data.message !== null) {
          setTimeout(function () {
            location.reload();
          }, 900);
          prependAlert(
            '#div_organizer_settings_button',
            data.message,
            'success',
            null,
            '#organizer_settings_form'
          );
        }
        popupAlert();
      })
      .fail(function (data) {
        if (
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }
        if (
          data.responseJSON.error_message !== undefined &&
          data.responseJSON.error_message !== null
        ) {
          prependAlert(
            '#div_organizer_settings_button',
            data.responseJSON.error_message,
            'danger',
            null,
            '#organizer_settings_form'
          );
        }
      });

    return false;
  });

  $(document).on('submit', '#organizer_settings_form', function () {
    function validateRequiredFields(form) {
      let isValid = true;
      $(form)
        .find('[required]')
        .each(function () {
          if ($(this).val().trim() === '') {
            isValid = false;
            $(this).addClass('is-invalid'); // Add an invalid class to highlight the empty fields
            // Optionally, you can show a custom message or use browser's built-in message
            $(this).next('.invalid-feedback').text('This field is required.');
          } else {
            $(this).removeClass('is-invalid');
            $(this).next('.invalid-feedback').text('');
          }
        });
      return isValid;
    }

    if (!organizer_settings_ajax_lock) {
      // Validate required fields before proceeding
      if (!validateRequiredFields(this)) {
        // Display a general error message if validation fails
        prependAlert(
          '#div_organizer_settings_button',
          'Vennligst fyll ut alle obligatoriske felter.',
          'danger',
          null,
          '#organizer_settings_form'
        );
        $('#saveSettingModel').modal('hide');
        showToast({
          type: 'error',
          message: 'Vennligst fyll ut alle obligatoriske felter.',
          duration: 4000,
        });
        return false;
      }

      organizer_settings_ajax_lock = true;
      // Remove Rabattkode (19) from all_payment[] and checkbox if promo_code is not active
      const promoCodeCheckbox = document.getElementById('promo_code');

      if (!promoCodeCheckbox || !promoCodeCheckbox.checked) {
        // Remove hidden input
        $('input[name="all_payment[]"][value="19"]').remove();

        // Uncheck and remove visual block
        $('input[name="default_payment[]"][value="19"]').prop('checked', false);
        $('div[data-payment-method="19"]').remove();
      } else {
        // If Rabattkode input is missing, add it back
        if ($('input[name="all_payment[]"][value="19"]').length === 0) {
          // 1. Add hidden input
          const input = $('<input>')
            .attr('type', 'hidden')
            .attr('name', 'all_payment[]')
            .val('19');
          $('#organizer_settings_form').append(input);

          // 2. Add checkbox UI block
          const rabattkodeHtml = `
      <div class="d-flex align-items-center mb-2 default-item-container" data-payment-method="19">
        <div class="default-item btn btn-outline-primary" data-id="default_payment_19">
          <div class="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox"
              class="custom-control-input default-payment"
              id="default_payment_19"
              name="default_payment[]"
              value="19"
              onchange="checkDefaultPayments()">
            <label class="custom-control-label" for="default_payment_19">
              Rabattkode
            </label>
          </div>
        </div>
        <div class="default-payment-list-order btn">
          <svg width="24" height="24" fill="black" viewBox="0 0 24 24">
            <path d="M10 4h4v2h-4V4zm0 7h4v2h-4v-2zm0 7h4v2h-4v-2z"/>
          </svg>
        </div>
      </div>
    `;

          $('.default-item-container').last().after(rabattkodeHtml);
        }
      }

      let formData = new FormData(
        document.getElementById('organizer_settings_form')
      );

      $.ajax({
        type: 'POST',
        url: '/ajax/organizer_settings/update',
        data: formData,
        enctype: 'multipart/form-data',
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          if (data.message !== undefined && data.message !== null) {
            popupAlert();
            showToast({
              type: 'success',
              message: data.message,
              duration: 4000,
            });
            $('#saveSettingModel').modal('hide');
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }

          if (
            data.responseJSON.error_message !== undefined &&
            data.responseJSON.error_message !== null
          ) {
            showToast({
              type: 'error',
              message: data.responseJSON.error_message,
              duration: 4000,
            });
          }
          $('#saveSettingModel').modal('hide');
          organizer_settings_ajax_lock = false;
        })
        .always(function () {
          $('#saveSettingModel').modal('hide');
          organizer_settings_ajax_lock = false;
        });
    }

    return false;
  });

  $(document).on('click', '#save-setting-cancel', function () {
    $('#saveSettingModel').modal('hide');
  });
  $(document).on('click', '#save-setting-confirm', function () {
    const disabledOnClick = $('#save-setting-confirm');
    const btnWidth = disabledOnClick.outerWidth();
    disabledOnClick.css('width', btnWidth + 'px');
    disabledOnClick.prop('disabled', true);
    disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');

    if (typeof updatePaymentOrder === 'function') {
      updatePaymentOrder();
    }

    $('#organizer_settings_form').submit();

    disabledOnClick.prop('disabled', false);
    disabledOnClick.html('Bekreft');
  });

  $(document).on('change', '#location_restaurant', function () {
    if ($(this).is(':checked')) {
      if ($('.location-restaurant-field-wrapper').hasClass('d-none')) {
        $('.location-restaurant-field-wrapper').removeClass('d-none');
      }
      $('#restaurant_preparation_time_kitchen').prop('required', true);
      $('#restaurant_preparation_time').prop('required', true);
    } else {
      if (!$('.location-restaurant-field-wrapper').hasClass('d-none')) {
        $('.location-restaurant-field-wrapper').addClass('d-none');
      }
      $('#restaurant_preparation_time_kitchen').val(null);
      $('#restaurant_preparation_time').val(null);
      $('#restaurant_preparation_time_kitchen').prop('required', false);
      $('#restaurant_preparation_time').prop('required', false);
    }
  });
  $(document).on('change', '#location_takeaway', function () {
    if ($(this).is(':checked')) {
      if ($('.location-takeaway-field-wrapper').hasClass('d-none')) {
        $('.location-takeaway-field-wrapper').removeClass('d-none');
      }
      $('#takeaway_preparation_time').prop('required', true);
      $('#number_of_days_you_can_order_before_pickup').prop('required', true);
    } else {
      $('#takeaway_preparation_time').val(null);
      $('#number_of_days_you_can_order_before_pickup').val(null);
      if (!$('.location-takeaway-field-wrapper').hasClass('d-none')) {
        $('.location-takeaway-field-wrapper').addClass('d-none');
      }
      $('#takeaway_preparation_time').prop('required', false);
      $('#number_of_days_you_can_order_before_pickup').prop('required', false);
    }
  });
  $(document).on('change', '#waiting_time_message', function () {
    if ($(this).is(':checked')) {
      if ($('.waiting-time-message-field-wrapper').hasClass('d-none')) {
        $('.waiting-time-message-field-wrapper').removeClass('d-none');
      }
      $('#minutes_before_waiting_time_message_activation').prop(
        'required',
        true
      );
    } else {
      $('#minutes_before_waiting_time_message_activation').val(null);
      if (!$('.waiting-time-message-field-wrapper').hasClass('d-none')) {
        $('.waiting-time-message-field-wrapper').addClass('d-none');
      }
      $('#minutes_before_waiting_time_message_activation').prop(
        'required',
        false
      );
    }
  });
  // Decrease button click handler
  $('#decrease_fontsize').on('click', function () {
    var $input = $('#fontsize_of_pos_product');
    var currentValue = parseInt($input.val()) || 0;
    var minValue = parseInt($input.attr('min')) || 0;
    var newValue = Math.max(minValue, currentValue - 1);
    $input.val(newValue);
    $input.trigger('change');
  });

  // Increase button click handler
  $('#increase_fontsize').on('click', function () {
    var $input = $('#fontsize_of_pos_product');
    var currentValue = parseInt($input.val()) || 0;
    var newValue = currentValue + 1;
    $input.val(newValue);
    $input.trigger('change');
  });

  $(document).on('change', '#payment_method_coupon', function () {
    if ($(this).is(':checked')) {
      if ($('.payment-method-coupon-field-wrapper').hasClass('d-none')) {
        $('.payment-method-coupon-field-wrapper').removeClass('d-none');
      }
      $('#max_orders_per_day_per_person_with_payment_method_coupon').prop(
        'required',
        true
      );
    } else {
      $('#max_orders_per_day_per_person_with_payment_method_coupon').val(null);
      if (!$('.payment-method-coupon-field-wrapper').hasClass('d-none')) {
        $('.payment-method-coupon-field-wrapper').addClass('d-none');
      }
      $('#max_orders_per_day_per_person_with_payment_method_coupon').prop(
        'required',
        false
      );
    }
  });

  // $(document).on("change", "#products_per_row", function () {
  //   if ($(this).is(":checked")) {
  //     if ($(".products-per-row-field-wrapper").hasClass("d-none")) {
  //       $(".products-per-row-field-wrapper").removeClass("d-none");
  //     }
  //     $("#number_products_per_row_activation").prop("required", true);
  //   } else {
  //     $("#number_products_per_row_activation").val(null);
  //     if (!$(".products-per-row-field-wrapper").hasClass("d-none")) {
  //       $(".products-per-row-field-wrapper").addClass("d-none");
  //     }
  //     $("#number_products_per_row_activation").prop("required", false);
  //   }
  // });

  $(document).on('change', '#number_products_per_row_activation', function () {
    let numberOfProductPerRow = $(this).val();
    numberOfProductPerRow = parseInt(numberOfProductPerRow, 10);

    if (isNaN(numberOfProductPerRow)) {
      alert('Vennligst oppgi et gyldig tall for produkter per rad.');
      numberOfProductPerRow = 2;
    } else if (numberOfProductPerRow > 15) {
      alert(
        'Vennligst oppgi et tall mindre enn eller lik 15 for produkter per rad.'
      );
      numberOfProductPerRow = 15;
    } else if (numberOfProductPerRow < 2) {
      alert(
        'Vennligst oppgi et tall større enn eller lik 2 for produkter per rad.'
      );
      numberOfProductPerRow = 2;
    }
    $(this).val(numberOfProductPerRow);
  });

  $(document).on(
    'change',
    '#location_restaurant_cart_customer_name',
    function () {
      if ($(this).is(':checked')) {
        if (
          $(
            '#location_restaurant_cart_customer_name_mandatory-wrapper'
          ).hasClass('d-none')
        ) {
          $(
            '#location_restaurant_cart_customer_name_mandatory-wrapper'
          ).removeClass('d-none');
        }
      } else {
        $('#location_restaurant_cart_customer_name_mandatory').prop(
          'checked',
          false
        );
        if (
          !$(
            '#location_restaurant_cart_customer_name_mandatory-wrapper'
          ).hasClass('d-none')
        ) {
          $(
            '#location_restaurant_cart_customer_name_mandatory-wrapper'
          ).addClass('d-none');
        }
      }
    }
  );
  $(document).on(
    'change',
    '#location_restaurant_cart_customer_phone_number',
    function () {
      if ($(this).is(':checked')) {
        if (
          $(
            '#location_restaurant_cart_customer_phone_number_mandatory-wrapper'
          ).hasClass('d-none')
        ) {
          $(
            '#location_restaurant_cart_customer_phone_number_mandatory-wrapper'
          ).removeClass('d-none');
        }
      } else {
        $('#location_restaurant_cart_customer_phone_number_mandatory').prop(
          'checked',
          false
        );
        if (
          !$(
            '#location_restaurant_cart_customer_phone_number_mandatory-wrapper'
          ).hasClass('d-none')
        ) {
          $(
            '#location_restaurant_cart_customer_phone_number_mandatory-wrapper'
          ).addClass('d-none');
        }
      }
    }
  );

  $(document).on('change', '#enable_pickup_registration', function () {
    if ($(this).is(':checked')) {
      if ($('#success_message_after_delivered-wrapper').hasClass('d-none')) {
        $('#success_message_after_delivered-wrapper').removeClass('d-none');
      }
    } else {
      if (!$('#success_message_after_delivered-wrapper').hasClass('d-none')) {
        $('#success_message_after_delivered-wrapper').addClass('d-none');
      }
    }
  });

  $(document).on(
    'change',
    '#recommended_max_orders_per_day_per_person_with_payment_method_coupon',
    function () {
      if (!checkMaxOrdersWithCoupon()) {
        alert(
          $('#payment-method-coupon-field-wrapper').attr(
            'data-recommended-max-coupons-message'
          )
        );
        $(this).val('');
      }
    }
  );
  $(document).on(
    'change',
    '#max_orders_per_day_per_person_with_payment_method_coupon',
    function () {
      if (!checkMaxOrdersWithCoupon()) {
        alert(
          $('#payment-method-coupon-field-wrapper').attr(
            'data-recommended-max-coupons-message'
          )
        );
        $(this).val('');
      }
      if (!checkTotalOrdersWithCoupon()) {
        alert(
          $('#payment-method-coupon-field-wrapper').attr(
            'data-max-coupons-message'
          )
        );
        $(this).val('');
      }
    }
  );
  $(document).on(
    'change',
    '#max_orders_per_day_with_payment_method_coupon',
    function () {
      if (!checkTotalOrdersWithCoupon()) {
        alert(
          $('#payment-method-coupon-field-wrapper').attr(
            'data-max-coupons-message'
          )
        );
        $(this).val('');
      }
    }
  );

  function checkMaxOrdersWithCoupon() {
    let recommendedMaxOrdersPerDayPerPerson = $(
      '#recommended_max_orders_per_day_per_person_with_payment_method_coupon'
    ).val();
    let maxOrdersPerDayPerPerson = $(
      '#max_orders_per_day_per_person_with_payment_method_coupon'
    ).val();
    if (
      recommendedMaxOrdersPerDayPerPerson != '' &&
      maxOrdersPerDayPerPerson != '' &&
      !isNaN(recommendedMaxOrdersPerDayPerPerson) &&
      !isNaN(maxOrdersPerDayPerPerson) &&
      recommendedMaxOrdersPerDayPerPerson > maxOrdersPerDayPerPerson
    ) {
      return false;
    }
    return true;
  }

  function checkTotalOrdersWithCoupon() {
    let maxOrdersPerDayPerPerson = parseInt(
      $('#max_orders_per_day_per_person_with_payment_method_coupon').val()
    );
    let totalOrdersPerDayPerPerson = parseInt(
      $('#max_orders_per_day_with_payment_method_coupon').val()
    );
    if (
      totalOrdersPerDayPerPerson != '' &&
      maxOrdersPerDayPerPerson != '' &&
      !isNaN(totalOrdersPerDayPerPerson) &&
      !isNaN(maxOrdersPerDayPerPerson) &&
      maxOrdersPerDayPerPerson > totalOrdersPerDayPerPerson
    ) {
      return false;
    }
    return true;
  }

  $(document).on('click', '.find-printer', function (e) {
    e.preventDefault();
    const location_id = $(this).data('location-id');

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ action: 'discovery' })
      );
    }

    // document.addEventListener("message", function (event) {
    //   savedFoundPrinters(event, location_id);
    // });
    // window.addEventListener("message", function (event) {
    //   savedFoundPrinters(event, location_id);
    // });

    $.ajax({
      type: 'POST',
      url: '/ajax/printer/get_find_printer_modal',
      data: { location_id },
    })
      .done(function (data) {
        if (data.html !== undefined && data.html !== null) {
          $('#printer-setting').after(data.html);
          $('#find-printer-modal').modal('show');
        }
      })
      .fail(function (data) {
        if (
          data.responseJSON.redirect_url !== undefined &&
          data.responseJSON.redirect_url !== null
        ) {
          document.location.href = data.responseJSON.redirect_url;
        }
      });

    $(document).on('hide.bs.modal', '#find-printer-modal', function () {
      $('.modal-backdrop').remove();
    });

    $(document).on('click', '.add-new-printer', function () {
      const currEle = $(this);
      const location_id = $(this).data('location-id');
      const name = $(this).data('name');
      const ip_address = $(this).data('printer-ip');
      const type = $(this).data('printer-type');

      $.ajax({
        type: 'POST',
        url: '/ajax/printer/new',
        data: { location_id, name, ip_address, status: 1, type },
      })
        .done(function (data) {
          currEle.closest('tr').fadeOut(1000);

          setTimeout(() => {
            currEle.closest('tr').remove();
            if ($('.printer-row').length <= 0) {
              $('#find-printer-modal').modal('hide');
              $('.modal-backdrop').remove();
              setTimeout(() => {
                $('#find-printer-modal').remove();
              }, 1000);
            }

            if ($('#printer-list-tbody').length > 0 && data.printer) {
              const newRow = generatePrinterRow(data.printer);
              $('#printer-list-tbody').append(newRow);
            }
          }, 1000);
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });
  });

  if (!window.ReactNativeWebView) {
    $('.find-printer').remove();
  }

  function generatePrinterRow(printer) {
    return `
      <tr id="printer-${printer.printer_id}">
        <td>${printer.name}</td>
        <td>${printer.ip_address}</td>
        <td>${printer.type}</td>
        <td class="d-flex justify-content-end">
          <button class="btn btn-primary mr-4 test-print"
                  onclick="passDataToWebView(event, 'test', [], '${printer.ip_address}', '${printer.type}')">
            Print
          </button>
          <button type="button"
                  class="btn printer-delete-btn btn-primary mr-4"
                  data-toggle="modal"
                  data-target="#printerDeleteConfirmationModal"
                  data-delete-id="${printer.printer_id}">
            Slett
          </button>
          <a href="/location/${printer.location_id}/printer/${printer.printer_id}/update" class="btn">
            <i class="material-icons">settings</i>
          </a>
        </td>
      </tr>
    `;
  }

  $(document).on('click', '.test-print', function (e) {
    e.preventDefault();
    const ip = $(this).data('printer-ip');
    const type = $(this).data('printer-type');

    if (type == 'TERMINAL') {
      $.ajax({
        type: 'POST',
        url: '/api/v1/private/printer/terminal-print',
        data: { terminal_id: ip, action: 'test' },
      })
        .done(function (data) {
          showToast({
            type: 'success',
            title: 'Success',
            message: 'Test print successful',
            position: 'top-right',
            duration: 4000,
          });
        })
        .fail(function (data) {
          if (
            data.responseJSON.error.message !== undefined &&
            data.responseJSON.error.message !== null
          ) {
            showToast({
              type: 'error',
              title: 'Error',
              message: data.responseJSON.error.message,
              position: 'top-right',
              duration: 4000,
            });
          }
        });
    } else {
      const currentDeviceId = localStorage.getItem('deviceID');
      const mainPOSDeviceId = $(this).attr('data-main-pos-device-id');
      if (mainPOSDeviceId && currentDeviceId != mainPOSDeviceId) {
        checkDeviceActive(mainPOSDeviceId).then(function (isActive) {
          if (isActive) {
            let socketData = {
              type: 'main-device-print-service',
              main_pos_device_id: mainPOSDeviceId,
              requested_device_id: currentDeviceId,
              printData: {
                action: 'test',
                data: [],
                ip,
                type,
              },
            };

            window.globalSocket.send(JSON.stringify(socketData));
          } else {
            showToast({
              type: 'error',
              message: 'Hoved POS-enheten må være aktiv for å kunne skrive ut.',
            });
          }
        });
      } else {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            action: 'test',
            data: [],
            ip,
            type,
          })
        );
      }
    }
  });

  if (p == 'organizer_settings') {
    if ($('#password-verification-modal').length) {
      $('#password-verification-modal').modal('show');
    }

    $(document).on('submit', '#password-verification-form', function (e) {
      e.preventDefault();
      const password = $('#user-password').val();
      const email = $('#user-email').val();

      $('#password-verification-error').html('');

      $.ajax({
        type: 'POST',
        url: '/ajax/user/verify_password',
        data: { password, email },
      })
        .done(function (data) {
          if (data.verified) {
            $('#password-verification-modal').modal('hide');
          } else {
            $('#password-error-message').removeClass('d-none');
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }

          if (
            data.responseJSON.error_message !== undefined &&
            data.responseJSON.error_message !== null
          ) {
            const alertHtml = getAlertHtml(
              data.responseJSON.error_message,
              'danger'
            );
            $('#password-verification-error').css('margin-top', '1rem');
            $('#password-verification-error').html(alertHtml);
          }
        });
    });

    $(document).on(
      'hide.bs.modal',
      '#password-verification-modal',
      function () {
        $('#password-verification-modal').remove();
      }
    );

    if ($('.cart-action-button-group').length) {
      // All three containers are connected sortable lists
      Sortable.create($('.always-show-buttons-section')[0], {
        group: 'payment-methods', // same group = can drag between lists
        handle: '.default-payment-list-order',
        animation: 150,
        draggable: '.default-item-container',
        ghostClass: 'sortable-ghost',
        dataIdAttr: 'data-payment-method',

        // When order changes OR item moves between lists
        onEnd: function (evt) {
          saveAllOrders();
        },
      });

      Sortable.create($('.default-show-buttons-section')[0], {
        group: 'payment-methods',
        handle: '.default-payment-list-order',
        animation: 150,
        draggable: '.default-item-container',
        ghostClass: 'sortable-ghost',
        dataIdAttr: 'data-payment-method',
        onEnd: saveAllOrders,
      });

      Sortable.create($('.nerver-show-in-this-device-section')[0], {
        group: 'payment-methods',
        handle: '.default-payment-list-order',
        animation: 150,
        draggable: '.default-item-container',
        ghostClass: 'sortable-ghost',
        dataIdAttr: 'data-payment-method',
        onEnd: saveAllOrders,
      });
    }

    $(document).on(
      'click',
      '#inactivity_clear_cart_timeout-checkbox',
      function () {
        if ($(this).is(':checked')) {
          $('#inactivity_clear_cart_timeout-input').val(120);
        } else {
          $('#inactivity_clear_cart_timeout-input').val(0);
        }
      }
    );

    function saveAllOrders() {
      const alwaysShow = $('.always-show-buttons-section')
        .find('.default-item-container')
        .map((_, el) => $(el).data('payment-method'))
        .get();

      const moreShow = $('.default-show-buttons-section')
        .find('.default-item-container')
        .map((_, el) => $(el).data('payment-method'))
        .get();

      const hidden = $('.nerver-show-in-this-device-section')
        .find('.default-item-container')
        .map((_, el) => $(el).data('payment-method'))
        .get();

      const orderData = {
        always_visible: alwaysShow,
        more_visible: moreShow,
        hidden: hidden,
      };

      $.ajax({
        type: 'POST',
        url: '/ajax/organizer/default_payment_list_sort',
        data: orderData,
        success: function (data) {
          if (data && data.success) {
            popupAlert(); // or show success message
          }
        },
        error: function (xhr) {
          if (xhr.responseJSON?.redirect_url) {
            document.location.href = xhr.responseJSON.redirect_url;
          } else {
            console.error('Save failed', xhr);
            // optionally revert or show error
          }
        },
      });
    }

    // passVerifoneDataToWebView({
    //   action: "verifone",
    //   data: {
    //     action: "get_device_info",
    //   },
    // });
  }

  $(document).on('change', 'input[name^="config["]', function () {
    const $input = $(this);

    if ($input.data('hide-child-config-on-unchecked') != 1) {
      return;
    }

    const $children = $input
      .closest('.form-row')
      .children('.form-group')
      .not($input.closest('.form-group'));

    if ($input.is(':checked')) {
      $children.removeClass('d-none');
    } else {
      $children.addClass('d-none');

      $children.find('input[type="checkbox"]').each(function () {
        $(this).prop('checked', false).trigger('change');
      });
    }
  });
});

function savedFoundPrinters(event, location_id) {
  const printers = JSON.parse(event.data);

  if (printers) {
    if (printers.length > 0) {
      $.ajax({
        type: 'POST',
        url: '/ajax/printer/get_discovered_printers',
        data: { location_id, printers },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $('#printer-modal-body').empty();
            $('#printer-modal-body').append(data.html);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    } else {
      $('#find-printer-modal').modal('hide');
      clearTimeout(window.printerTimeout);

      window.printerTimeout = setTimeout(() => {
        $('#find-printer-modal').remove();
        alert('Finner ingen skriver');
      }, 250);
    }
  }

  $(document).on('change', '#gift-card-maximum-sum', function () {
    const maxSum = $(this).val();
    const minSum = $('#gift-card-minimum-sum').val();

    if (maxSum < minSum) {
      const errorDiv = $('#gift-card-amount-error');
      if (errorDiv.hasClass('d-none')) {
        errorDiv.removeClass('d-none');
      }
      $(this).val('');
      $(this).focus();
    } else {
      if (!errorDiv.hasClass('d-none')) {
        errorDiv.addClass('d-none');
      }
    }
  });
}

$(document).on('click', '#add-more-picture', function () {
  const pictureCount = $('.customer-screen-picture:not(.d-none)').length;

  if (pictureCount == 3) {
    alert('Maksimalt 3 bilder kan legges til');
    return;
  } else {
    $('.customer-screen-picture.d-none').first().removeClass('d-none');
  }
});

$(document).on('click', '.default-item', function (e) {
  // Prevent toggling if the click is directly on the checkbox or label
  if ($(e.target).is('input, label')) return;

  const checkboxId = $(this).data('id');
  const checkbox = $('#' + checkboxId);

  if (!checkbox.prop('disabled')) {
    checkbox.prop('checked', !checkbox.prop('checked')).trigger('change');
  }
});
